import { Component, Input, Output, OnInit, ViewChild, EventEmitter } from '@angular/core'
import { Router } from '@angular/router'

import { GroupsService } from '../../services/groups.service'
import { UsersService } from '../../services/users.service'
import { MessagesDelegate } from '../../services/messages-delegate.service'
import { EventsEmitterService } from '../../services/events-emitter.service'

import { Group, Visibility } from '../../models/group.model'
import { GroupForm } from '../../models/group-form.model'

import { SuiModalService } from 'ng2-semantic-ui'
import { ConfirmModal } from '../confirm-modal/confirm-modal.component'

@Component({
  selector: 'ld-groups-form',
  template: require('./groups-form.component.html'),
  styles: [require('./groups-form.component.css')]
})
export class GroupsFormComponent implements OnInit {
  @Input('group') group = new Group()
  @Output('groupChange') groupChange = new EventEmitter<Group>()
  @ViewChild('groupForm') groupForm
  private form = new GroupForm()
  private Visibility = Visibility

  constructor (
    private groupsService: GroupsService,
    private usersService: UsersService,
    private messagesDelegate: MessagesDelegate,
    private eventsEmitterService: EventsEmitterService,
    private router: Router,
    private modalService: SuiModalService) {}

  ngOnInit () {
    this.form.fill(this.group)
  }

  ngAfterContentInit () {
    // remove author from member list
    this.form.users = this.form.users.filter((u) => u.id !== this.group.author.id)
  }

  async onSubmit () {
    const isEditing = this.group.id !== ''

    // add author to member list
    const author = this.group.users.find((u) => u.id === this.group.author.id)
    if (author) this.form.users.push(author)

    try {
      this.group = await this.groupsService[this.group.id ? 'put' : 'post'](this.form.toRequestData())
      this.groupChange.emit(this.group)
    } catch (e) {
      this.messagesDelegate.add(e.message)
      return
    }

    if (isEditing) {
      this.messagesDelegate.add('APP.GROUP.UPDATED')
      this.eventsEmitterService.emit('editing', false)
    } else {
      this.messagesDelegate.add('APP.USER.CREATED', true)
      this.router.navigate(['/group', this.group.id])
    }
  }

  delete () {
    this.modalService
      .open(new ConfirmModal('Suppression', 'Le groupe et tous les événements associés seront supprimés. Continuer ?'))
      .onApprove(async () => {
        try {
          await this.groupsService.delete(this.group.id)
          this.messagesDelegate.add('APP.GROUP.DELETED', true)
          this.router.navigate(['/groups'])
        } catch (e) {
          this.messagesDelegate.add(e.message)
        }
      })
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/groups-form/groups-form.component.ts